import '@babel/runtime/helpers/esm/toConsumableArray';
import '@babel/runtime/helpers/esm/defineProperty';
import { isFunction } from 'lodash';

var setRef = function setRef(ref, value) {
  if (isFunction(ref)) {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
};
function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (node) {
    if (!node) return;
    refs.forEach(function (ref) {
      if (isFunction(ref)) {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    });
  };
}
function logger(log) {
}

export { logger, mergeRefs, setRef };
//# sourceMappingURL=system.js.map
